// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2F-c7","right":"styles_right__14gYB"};